import { getSpeakerSpeed } from '../services/UserSettingService';

export const defaultSpeed = 0.9;
export const minSpeed = 0.5;  // 0.4以下だとmacOSのChromeで速度が強制的に1.0で発話される
export const maxSpeed = 1.3;

const msg = new SpeechSynthesisUtterance();

// 発話のAPIの基本設定初期化
const initMsg = () => {
    const voices = speechSynthesis.getVoices();
    const voice = voices.find((_) => _.lang === 'ja-JP');
    if (voice) {
        msg.voice = voice;
    }
    msg.volume = 1.0;
    msg.pitch = 1.0;
    msg.lang = 'ja-JP';
};

/**
 * すでに話している内容をキャンセルして、新しいテキストを発話させる。
 */
export function speak(text: string) {
    speechSynthesis.cancel();
    msg.rate = getSpeakerSpeed(defaultSpeed);
    msg.text = text;
    speechSynthesis.speak(msg);
}

initMsg();
